import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { ICustomerResultModel } from "../models/customer/customer-result.model";
import { IPaginationRequestBaseModel } from "../models/generic/pagination/pagination-request.base.model";
import { IPaginationResponseModel } from "../models/generic/pagination/pagination-response.base.model";
import { IDataService } from "./data.service";

@Injectable({
    providedIn: 'root'
  })
export class ProductDetailsService implements  IDataService<ICustomerResultModel> {
    get(id: string): Observable<ICustomerResultModel> {
        return of();
    }
    getAll(paginationModel: IPaginationRequestBaseModel): Observable<IPaginationResponseModel<ICustomerResultModel>> {
        return of();
    }
    update(model: ICustomerResultModel): Observable<ICustomerResultModel> {
        return of();
    }
    save(model: ICustomerResultModel): Observable<number> {
        return of();
    }
    delete(model: ICustomerResultModel): Observable<boolean> {
        return of();
    }
}